module.exports = __webpack_public_path__ + "static/hands-5fe92cfa1422459eeb53c9704476f916.mp4";